import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { useBoolean } from "../../../hooks/common/useBoolean";
import { SaveIcon } from "../icons/SaveIcon";

export function SaveButton(props: ButtonHTMLAttributes<any>) {

    const [openTooltip, open, close,] = useBoolean();

    return (
        <div className="save_button_area">
            <button className="save_button" {...props} onMouseEnter={open} onMouseLeave={close}>
                <SaveIcon />
            </button>
            <div className={classNames("tooltip", { "active": openTooltip })}>
                保存
            </div>
        </div>
    );
}
